export default __webpack_public_path__ + "static/media/d1.bfad8f08.svg";